import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DotacionInicialService {
  private storageKey: string = 'dotacionInicial';
  private dotacionInicialSource = new BehaviorSubject<number>(this.getInitialDotacion());

  dotacionInicial$ = this.dotacionInicialSource.asObservable();

  constructor() {}

  // Guarda la dotación inicial en el almacenamiento local y emite el nuevo valor
  setDotacionInicial(dotacionInicial: number): void {
    localStorage.setItem(this.storageKey, dotacionInicial.toString());
    this.dotacionInicialSource.next(dotacionInicial);
  }

  // Obtiene el valor inicial de la dotación desde el almacenamiento local
  private getInitialDotacion(): number {
    const storedDotacion = localStorage.getItem(this.storageKey);
    return storedDotacion ? parseInt(storedDotacion) : 0;
  }

}
